function changeFileName() {
    const containerInputs = document.querySelectorAll("fieldset.input-file")

    containerInputs.forEach(container => {
        container.querySelector("input").addEventListener('change', (event) => {
            if (event.target.files.length == 0) {
                container.querySelectorAll(".input-file__name")[0].innerHTML = "Nenhum arquivo escolhido"
                return
            }

            const selectedFile = event.target.files[0];
            const fileName = selectedFile?.name;

            container.querySelectorAll(".input-file__name")[0].innerHTML = fileName
        });
    })
}

if(document.querySelector("fieldset.input-file")){
    changeFileName()
}